import { Vector3 } from '@babylonjs/core/Maths';
import { SolidParticle } from '@babylonjs/core/Particles/solidParticle';
import { LinearPatternFeature } from '@models/classes/features/linear-pattern-feature';
import { Token } from '@models/classes/token';
import { SubmeshVertexData } from '@view/helpers/geometry-helper';
import { PatternRenderer } from './pattern';

export class LinearPatternRenderer extends PatternRenderer {
    modelToken = Token.LinearPatternFeature;
    updateMeshGeometry(
        feature: LinearPatternFeature,
        vertexData: SubmeshVertexData,
        vertexDataChanges: Partial<SubmeshVertexData>
    ) {
        const featureTranslation = feature.translation.toVec3();
        const workingVector = Vector3.Zero();

        return super.updateMeshGeometry(
            feature,
            vertexData,
            vertexDataChanges,
            (idx: number, particle: SolidParticle) => {
                if (!feature.meshId) {
                    workingVector.copyFrom(featureTranslation).scaleInPlace(idx);
                }
                particle.position.addInPlace(workingVector);
            }
        );
    }
}
